import { applyCost, canAffordCost } from '../map/settlement';
import type { ModalActionHandler } from './modalActionTypes';
import { getSettlement } from './settlementActionUtils';
import { queueConstruction } from '../economy/construction';
import { canQueueBuilding } from '../economy/settlementLimits';

export const buildStableAction: ModalActionHandler = (state, modal) => {
    const settlement = getSettlement(state, modal);
    if (!settlement) return false;
    if (!canQueueBuilding(settlement, 'stable')) return false;
    const cost = state.config.buildings.stable.cost || {};
    if (!canAffordCost(settlement, cost)) return false;
    applyCost(settlement, cost);
    queueConstruction(settlement, 'stable', state.simulation.tick, cost);
    return true;
};
